<template>
  <div>
    <site-header></site-header>
    <img src="@/assets/1747793251984.jpg" alt="main image" class="main-image">
    <div class="home-buttons">
      <div class="home-button" @click="scrollToSection('news')">新闻动态</div>
      <div class="home-button" @click="scrollToSection('archives')">档案研学</div>
      <div class="home-button" @click="scrollToSection('project')">项目研究</div>
    </div>
    <div id="news" class="news-section">
      <div class="news-main">
        <div class="news-header">
          <div class="news-title">新闻动态<br /><span>News and Trends</span></div>
        </div>
        <div class="news-content">
          <div class="news-carousel">
            <div v-if="newsList.length" class="carousel-img-wrap" @click="goToDetails(newsList[currentIndex], 'news')">
              <img :src="newsList[currentIndex].messageImg" :alt="newsList[currentIndex].messageName"
                class="carousel-img" />
              <div class="carousel-title">{{ newsList[currentIndex].messageName }}</div>
            </div>
          </div>
          <div class="news-list-wrap">
            <ul class="news-list">
              <li v-for="(item, index) in newsList.slice(0, 5)" :key="item.id || index" class="news-list-item"
                @click="goToDetails(item, 'news')">
                <span class="news-title2">{{ item.messageName }}</span>
              </li>
            </ul>
            <div class="news-more-wrap">
              <button class="news-more-btn" @click="$router.push('/news')">MORE <span
                  style="font-size:18px;vertical-align:middle;">&rsaquo;</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="archives" class="archives-research-section">
      <div class="archives-research-main">
        <div class="archives-research-header">
          <div class="archives-research-title">档案研学<br /><span>Archives Research</span></div>
          <div class="archives-research-buttons">
            <button :class="{ 'ar-button': true, 'active': activeArTab === 'specialist' }"
              @click="activeArTab = 'specialist'">专家</button>
            <button :class="{ 'ar-button': true, 'active': activeArTab === 'teacher' }"
              @click="activeArTab = 'teacher'">师资</button>
          </div>
        </div>
        <div class="ar-list-wrap">
          <div :class="['ar-list', { 'teacher-active': activeArTab === 'teacher' }]">
            <div v-for="(person, index) in displayedArList" :key="person.id || index" class="ar-item"
              @click="goToDetails(person, activeArTab)">
              <img :src="person.photograph" :alt="person.name" class="ar-photo" />
              <div class="ar-info">
                <div class="ar-name">{{ person.name }}</div>
                <div v-if="person.unit" class="ar-unit">{{ person.unit }}</div>
                <div v-if="person.position" class="ar-position">{{ person.remark || person.position }}</div>
                <div v-else-if="person.remark" class="ar-position">{{ person.remark }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="ar-more-wrap">
          <button class="ar-more-btn" @click="$router.push('/volume?category=4')">查看更多 <span
              style="font-size:18px;vertical-align:middle;">&rsaquo;</span></button>
        </div>
      </div>
    </div>
    <div id="project" class="project-research-section">
      <div class="project-research-main">
        <div class="project-research-header">
          <div class="project-research-title">项目研究<br /><span>Project research</span></div>
        </div>
        <div class="project-research-content">
          <div class="pr-left" v-if="projectResearchList.length" @click="goToProjectDetails(projectResearchList[0])">
            <div class="pr-image-wrap">
              <img :src="projectResearchList[0].cover" :alt="projectResearchList[0].title" class="pr-image" />
              <div class="pr-image-title">{{ projectResearchList[0].title }}</div>
            </div>
            <!-- <div class="pr-more-wrap pr-left-more">
              <button class="pr-more-btn">MORE <span
                  style="font-size:18px;vertical-align:middle;">&rsaquo;</span></button>
            </div> -->
          </div>
          <div class="pr-right">
            <ul class="pr-list">
              <li v-for="(item, index) in projectResearchList.slice(0, 5)" :key="item.id || index" class="pr-list-item"
                @click="goToProjectDetails(item)">
                <span class="pr-title">{{ item.title }}</span>
                <span v-if="item.itemTime" class="pr-date">{{ item.itemTime.split(' ')[0] }}</span>
              </li>
            </ul>
            <div class="pr-more-wrap pr-right-more">
              <button class="pr-more-btn" @click="$router.push('/project')">MORE <span
                  style="font-size:18px;vertical-align:middle;">&rsaquo;</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <site-footer></site-footer>
  </div>
</template>

<script>
import siteHeader from "../components/SiteHeader.vue";
import siteFooter from "../components/SiteFooter.vue";
import { getNewsMessage, getSpecialist, getTeachers, getLtItemDaList } from "@/api/website";

export default {
  name: "HomePage",
  components: {
    siteHeader,
    siteFooter,
  },
  data() {
    return {
      newsList: [], // 新闻列表
      currentIndex: 0, // 当前轮播索引
      intervalId: null, // 轮播定时器
      specialistList: [], // 专家列表
      teacherList: [], // 师资列表
      activeArTab: 'specialist', // 当前活跃的档案研学 tab: 'specialist' or 'teacher'
      projectResearchList: [], // 项目研究列表
    };
  },
  created() {
    this.fetchNews();
    this.fetchSpecialists();
    this.fetchTeachers();
    this.fetchProjectResearch();
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  },
  methods: {
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    goToDetails(item, type) {
      const query = {};
      switch (type) {
        case 'news':
          query.id = item.id; // Still using ID for news based on previous conversation
          this.$router.push({
            path: '/details',
            query: query
          });
          break;
        case 'specialist':
        case 'teacher':
          this.$router.push({
            path: '/expert-detail',
            query: { [type]: item }
          });
          break;
        case 'item':
          query.item = item; // Pass the whole item for project research (assuming 'item' type)
          this.$router.push({
            path: '/details',
            query: query
          });
          break;
        // Add more cases for other types if needed
        default:
          // Fallback or error handling if type is unknown
          console.error("Unknown item type for navigation:", type);
          return; // Prevent navigation for unknown types
      }
    },
    goToProjectDetails(item) {
      this.$router.push({
        path: '/ProjectDetails',
        query: {
          id: item.id,
          type: 'project'
        }
      });
    },
    async fetchNews() {
      try {
        const res = await getNewsMessage({ pageNum: 1, pageSize: 8 }); // Fetch enough data for carousel and list
        if (res && res.rows) {
          this.newsList = res.rows;
          if (this.newsList.length > 1) {
            this.startCarousel();
          }
        }
      } catch (e) {
        console.error("获取新闻列表失败:", e);
        // 可加错误提示
      }
    },
    startCarousel() {
      if (this.intervalId) clearInterval(this.intervalId);
      this.intervalId = setInterval(() => {
        const max = this.newsList.length; // Cycle through all fetched news for the left side
        if (max > 0) {
          this.currentIndex = (this.currentIndex + 1) % max;
        }
      }, 3000); // 3秒切换一次
    },
    async fetchSpecialists() {
      try {
        const res = await getSpecialist();
        if (res && res.rows) {
          this.specialistList = res.rows;
        }
      } catch (e) {
        console.error("获取专家列表失败:", e);
      }
    },
    async fetchTeachers() {
      try {
        const res = await getTeachers();
        if (res && res.rows) {
          this.teacherList = res.rows;
        }
      } catch (e) {
        console.error("获取师资列表失败:", e);
      }
    },
    async fetchProjectResearch() {
      try {
        const res = await getLtItemDaList();
        if (res && res.rows) {
          this.projectResearchList = res.rows;
        }
      } catch (e) {
        console.error("获取项目研究列表失败:", e);
      }
    },
    goToVolumeExpert() {
      this.$router.push('/volume');
      // 使用 nextTick 确保路由跳转完成后再触发栏目切换
      this.$nextTick(() => {
        const volumeComponent = this.$root.$children.find(child => child.$options.name === 'VolumePage');
        if (volumeComponent) {
          volumeComponent.fetchVolumes('4');
        }
      });
    },
  },
  computed: {
    displayedArList() {
      return this.activeArTab === 'specialist' ? this.specialistList : this.teacherList;
    }
  },
};
</script>

<style scoped>
.main-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
}

.home-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  margin: 30px 0 40px 0;
}

.home-button {
  min-width: 220px;
  min-height: 80px;
  background: #fff;
  border: 2px solid #e0e0e0;
  border-radius: 16px 16px 16px 16px/20px 20px 20px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #2d437c;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  transition: box-shadow 0.2s, border-color 0.2s, background 0.3s, color 0.2s, transform 0.2s;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.home-button:hover {
  border-color: #3c4a6b;
  box-shadow: 0 6px 18px rgba(60, 74, 107, 0.10);
  color: #fff;
  background: linear-gradient(90deg, #3c4a6b 0%, #55608a 100%);
}

.news-section {
  width: 100%;
  background: #fafbfc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0 40px 0;
}

.news-main {
  width: 1200px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  padding: 40px;
  position: relative;
  margin-top: 40px;
}

.news-header {
  width: 100%;
  font-size: 28px;
  color: #2d437c;
  font-weight: 600;
  text-align: left;
  letter-spacing: 1px;
  margin-bottom: 30px;
}

.news-content {
  display: flex;
  gap: 30px;
  flex-direction: row;
  align-items: flex-start;
}

.news-carousel {
  flex: 1.4;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 520px;
  max-width: 520px;
  min-height: 320px;
  max-height: 320px;
}

.carousel-img-wrap {
  width: 520px;
  height: 320px;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(60, 74, 107, 0.08);
  background: #eee;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.carousel-title {
  width: 100%;
  background: rgba(44, 54, 94, 0.98);
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  padding: 16px 22px 14px 22px;
  box-sizing: border-box;
  border-radius: 0 0 6px 6px;
  margin: 0;
  position: relative;
  bottom: 0;
  left: 0;
  line-height: 1.5;
  min-height: 48px;
  max-height: 3.2em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.news-list-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-left: 30px;
  min-width: 0;
}

.news-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.news-list-item {
  font-size: 16px;
  color: #222;
  border-bottom: 1px solid #e5e5e5;
  padding: 14px 0 10px 0;
  cursor: pointer;
  transition: color 0.2s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-list-item:hover .news-title2 {
  color: #3c4a6b;
  text-decoration: underline;
}

.news-title2 {
  transition: color 0.2s;
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-more-wrap {
  margin-top: 32px;
  text-align: right;
}

.news-more-btn {
  background: #3c4a6b;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 36px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.news-more-btn:hover {
  background: #2d437c;
}

.archives-research-section {
  width: 100%;
  background: #fafbfc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0 40px 0;
}

.archives-research-main {
  width: 1200px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: block;
  position: relative;
  margin-top: 40px;
  padding: 40px 40px 70px 40px;
}

.archives-research-header {
  width: 100%;
  font-size: 28px;
  color: #2d437c;
  font-weight: 600;
  text-align: left;
  letter-spacing: 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  box-sizing: border-box;
}

.archives-research-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
}

.ar-button {
  background: #fff;
  border: 2px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 20px;
  font-size: 16px;
  color: #2d437c;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s;
}

.ar-button:hover {
  border-color: #3c4a6b;
}

.ar-button.active {
  background: #3c4a6b;
  color: #fff;
}

.ar-list-wrap {
  display: block;
  min-width: 0;
}

.ar-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
  margin-bottom: 30px;
}

.ar-list.teacher-active .ar-item {
  width: calc(25% - 22.5px);
  /* Calculate width for 4 items per row with gap */
}

.ar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
  width: calc(33.33% - 20px);
  border-bottom: none;
  padding: 0;
  text-align: center;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.ar-item:hover {
  background: #fafbfc;
}

.ar-photo {
  width: 100%;
  height: 200px;
  object-fit: contain;
  display: block;
}

.ar-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  flex-grow: 1;
  justify-content: center;
}

.ar-name {
  font-size: 18px;
  color: #222;
  font-weight: 600;
  margin-bottom: 8px;
}

.ar-unit {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.ar-position {
  font-size: 14px;
  color: #666;
}

.ar-more-wrap {
  position: absolute;
  bottom: 30px;
  right: 40px;
}

.ar-more-btn {
  background: #3c4a6b;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 36px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.ar-more-btn:hover {
  background: #2d437c;
}

.project-research-section {
  width: 100%;
  background: #fff;
  /* Background color for this section */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  /* Adjust padding top and bottom */
}

.project-research-main {
  width: 1200px;
  background: #fff;
  /* Background color for the inner content area */
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 40px;
  /* Inner padding */
  display: flex;
  flex-direction: column;
  /* Stack header and content vertically */
}

.project-research-header {
  width: 100%;
  font-size: 28px;
  color: #2d437c;
  font-weight: 600;
  margin-bottom: 30px;
  /* Space below header */
  text-align: left;
  letter-spacing: 1px;
}

.project-research-content {
  display: flex;
  gap: 30px;
  /* Space between left and right columns */
}

.pr-left {
  flex: 1;
  /* Take up proportional space */
  display: flex;
  flex-direction: column;
  cursor: pointer;
  /* Add cursor pointer to indicate clickable */
}

.pr-image-wrap {
  width: 100%;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(60, 74, 107, 0.08);
}

.pr-image {
  width: 100%;
  height: 300px;
  /* Fixed height for the image */
  object-fit: cover;
  /* Cover the area, cropping if necessary */
  display: block;
}

.pr-image-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(44, 54, 94, 0.9);
  /* Semi-transparent dark background */
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  padding: 12px 20px;
  box-sizing: border-box;
}

.pr-right {
  flex: 1;
  /* Take up proportional space */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* Push list to top and button to bottom */
}

.pr-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.pr-list-item {
  font-size: 16px;
  color: #222;
  border-bottom: 1px solid #e5e5e5;
  padding: 12px 0;
  cursor: pointer;
  transition: color 0.2s;
  display: flex;
  justify-content: space-between;
  /* Title on left, date on right */
  align-items: center;
}

.pr-list-item:hover .pr-title {
  color: #3c4a6b;
  text-decoration: underline;
}

.pr-title {
  flex-grow: 1;
  /* Allow title to take up available space */
  margin-right: 10px;
  /* Space between title and date */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pr-date {
  font-size: 14px;
  color: #999;
  flex-shrink: 0;
  /* Prevent date from shrinking */
}

.pr-more-wrap {
  text-align: right;
  margin-top: 20px;
  /* Space above the button */
}

.pr-more-btn {
  background: #fff;
  color: #2d437c;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px 36px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
}

.pr-more-btn:hover {
  background: #2d437c;
  color: #fff;
  border-color: #2d437c;
}

.pr-left-more,
.pr-right-more {
  /* Specific positioning might be needed based on final layout */
}

.news-title,
.archives-research-title,
.project-research-title {
  font-size: 28px;
  color: #2d437c;
  font-weight: 600;
  text-align: left;
  letter-spacing: 1px;
}

.news-title2 {
  font-size: 14px;
}

.news-title br,
.archives-research-title br,
.project-research-title br {
  content: '';
  display: block;
  /* margin-bottom: 4px; Adjust spacing as needed */
}

.news-title span,
.archives-research-title span,
.project-research-title span {
  font-size: 18px;
  /* Adjust size as needed */
  font-weight: 400;
  color: #555;
  /* Adjust color as needed */
  display: inline-block;
  margin-top: 4px;
  /* Space above English text */
  padding-bottom: 4px;
  /* Space below English text before underline */
  border-bottom: 2px solid #3c4a6b;
  /* Underline style */
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .main-image {
    width: 100%;
    height: auto;
  }

  .home-buttons {
    flex-direction: column;
    gap: 15px;
    margin: 20px 0;
    padding: 0 20px;
  }

  .home-button {
    width: 100%;
    min-width: auto;
    min-height: 60px;
    font-size: 18px;
  }

  .news-section,
  .archives-research-section,
  .project-research-section {
    padding: 20px 0;
  }

  .news-main,
  .archives-research-main,
  .project-research-main {
    width: 100%;
    margin: 20px 0;
    padding: 20px;
    border-radius: 0;
  }

  .news-header,
  .archives-research-header,
  .project-research-header {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .news-title,
  .archives-research-title,
  .project-research-title {
    font-size: 22px;
  }

  .news-title span,
  .archives-research-title span,
  .project-research-title span {
    font-size: 14px;
  }

  .news-content {
    flex-direction: column;
    gap: 20px;
  }

  .news-carousel {
    min-width: 100%;
    max-width: 100%;
    min-height: 220px;
    max-height: 220px;
  }

  .carousel-img-wrap {
    width: 100%;
    height: 220px;
  }

  .carousel-title {
    font-size: 16px;
    padding: 12px 16px;
  }

  .news-list-wrap {
    padding-left: 0;
    width: 100%;
  }

  .news-list {
    width: 100%;
  }

  .news-list-item {
    font-size: 14px;
    padding: 12px 0;
    width: 100%;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    display: flex;
    align-items: flex-start;
  }

  .news-title2 {
    font-size: 14px;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.5;
    max-width: 100%;
    word-break: break-word;
  }

  .news-more-wrap {
    margin-top: 20px;
    text-align: center;
  }

  .news-more-btn {
    width: 100%;
    max-width: 300px;
    padding: 12px 20px;
    font-size: 15px;
  }

  .archives-research-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .archives-research-buttons {
    width: 100%;
    justify-content: flex-start;
    gap: 10px;
  }

  .ar-button {
    flex: 1;
    padding: 10px 15px;
    font-size: 14px;
  }

  .archives-research-main {
    padding: 20px 20px 60px 20px;
  }

  .ar-list {
    gap: 15px;
    margin-bottom: 20px;
  }

  .ar-item {
    width: calc(50% - 7.5px) !important;
  }

  .ar-list.teacher-active .ar-item {
    width: calc(50% - 7.5px) !important;
  }

  .ar-photo {
    height: 150px;
  }

  .ar-info {
    padding: 12px;
  }

  .ar-name {
    font-size: 16px;
  }

  .ar-unit,
  .ar-position {
    font-size: 12px;
  }

  .ar-more-wrap {
    bottom: 20px;
    right: 20px;
    left: 20px;
  }

  .ar-more-btn {
    width: 100%;
    padding: 12px 20px;
  }

  .project-research-content {
    flex-direction: column;
    gap: 20px;
  }

  .pr-left {
    width: 100%;
  }

  .pr-image {
    height: 200px;
  }

  .pr-image-title {
    font-size: 16px;
    padding: 10px 16px;
  }

  .pr-right {
    width: 100%;
  }

  .pr-list-item {
    font-size: 14px;
    padding: 10px 0;
  }

  .pr-title {
    font-size: 14px;
  }

  .pr-date {
    font-size: 12px;
  }

  .pr-more-wrap {
    margin-top: 15px;
    text-align: center;
  }

  .pr-more-btn {
    width: 100%;
    padding: 12px 20px;
  }
}
</style>
